export default "__VITE_ASSET__DrhLl6R0__"